export default "__VITE_ASSET__36d5717a__"